import { render } from "./RoundSection.vue?vue&type=template&id=6b0655f6&ts=true"
import script from "./RoundSection.vue?vue&type=script&lang=ts"
export * from "./RoundSection.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__